
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/meteo",
      function () {
        return require("private-next-pages/[region]/[resort]/meteo.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/meteo"])
      });
    }
  